module.exports = __webpack_public_path__ + "static/media/carestack.923dc5f0.svg";